import React from 'react'

const Special = () => {
    return (
        <>
            <div className="special__offers">
                <h1>Special Offers</h1>
               <div className="special__offers__content">
               <div className="left">
                  <h2>Workshops & events</h2>
                  <p>Register before 22 Jan to get your favourite Events and Workshops on Offer Prices.</p>
                </div>
                <div className="right">
                    <h2>General Entry !</h2>
                    <h3>Price :<span>INR 400</span></h3>
                     <h4>Includes Accomodation & Food for two days</h4>
                    <h3>Price :<span>INR 250</span></h3>
                     <h4>Includes Accomodation & Food for one day</h4>
                </div>
               </div>
              
            </div>
        </>
    )
}

export default Special
